<div class="legends" (click)="$event.stopPropagation()">
  <span class="ep-text-medium-14 title">{{ 'module.shared.legends.switchDisplayLegendsTitleText' | translate }}</span>

  <div class="layer-action consumer-container" *ngIf="!!authService.permissions.ENERGY_MAP_CONSUMERS" (click)="toggleIcons('consumers')">
    <span class="ep-text-regular-12 ep-text-primary-text">{{ 'module.shared.legends.consumerLegendsLabelText' | translate }}</span>
    <span class="icon" [ngClass]="(legendsService._isConsumersVisible$ | async) ? 'fa fa-eye' : 'fa fa-eye-slash'"> </span>
  </div>
  <div class="layer-action streetLight-container" *ngIf="!!authService.permissions.ENERGY_MAP_STREETLIGHTS" (click)="toggleIcons('streetlights')">
    <span class="ep-text-regular-12 ep-text-secondary-text">{{ 'module.shared.legends.streetLightingLegendsLabelText' | translate }}</span>
    <span class="icon" [ngClass]="(legendsService._isStreetLightsVisible$ | async) ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
  </div>
  <div class="layer-action heatmap-container" *ngIf="!!authService.permissions.ENERGY_MAP_STREETLIGHTS" (click)="toggleIcons('heatmap')">
    <div class="indent-container">
      <app-svg-icon class="filter-indent-arrow" src="./assets/icons/filter-indent-arrow.svg"></app-svg-icon>
      <span class="ep-text-regular-12 ep-text-secondary-text">{{ 'module.shared.legends.heatmapLegendsLabelText' | translate }}</span>
    </div>
    <div class="indent-legend">
      <span class="icon" [ngClass]="(legendsService._isStreetLightsHeatmap$ | async) ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
    </div>
  </div>

  <ng-container *ngIf="!!authService.permissions.ENERGY_MAP_PRODUCERS && availableProducers && availableProducers.length > 0">
    <div class="layer-action producer-container" (click)="toggleIcons('producers')">
      <span class="ep-text-regular-12 ep-text-secondary-text">{{ 'module.shared.legends.producerLegendsLabelText' | translate }}</span>
      <span [ngClass]="visibility.isProducersVisible ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
    </div>
    <div
      class="layer-action producer-container"
      *ngIf="(legendsService.availableProducers$ | async)?.includes('Photovoltaik')"
      (click)="toggleIcons('Photovoltaik')"
    >
      <div class="indent-container">
        <app-svg-icon class="filter-indent-arrow" src="./assets/icons/filter-indent-arrow.svg"></app-svg-icon>
        <span class="ep-text-regular-12 ep-text-secondary-text">{{ 'module.shared.legends.energyTypesLegendsLabelText.photovoltaik' | translate }}</span>
      </div>
      <div class="indent-legend">
        <span class="icon" [ngClass]="(legendsService._isPhotovoltaikVisible$ | async) ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
      </div>
    </div>
    <div class="layer-action producer-container" *ngIf="(legendsService.availableProducers$ | async)?.includes('Wind')" (click)="toggleIcons('Wind')">
      <div class="indent-container">
        <app-svg-icon class="filter-indent-arrow" src="./assets/icons/filter-indent-arrow.svg"></app-svg-icon>
        <span class="ep-text-regular-12 ep-text-secondary-text">{{ 'module.shared.legends.energyTypesLegendsLabelText.windenergie' | translate }}</span>
      </div>
      <div class="indent-legend">
        <span class="icon" [ngClass]="(legendsService._isWindVisible$ | async) ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
      </div>
    </div>
    <div class="layer-action producer-container" *ngIf="(legendsService.availableProducers$ | async)?.includes('Wasser')" (click)="toggleIcons('Wasser')">
      <div class="indent-container">
        <app-svg-icon class="filter-indent-arrow" src="./assets/icons/filter-indent-arrow.svg"></app-svg-icon>
        <span class="ep-text-regular-12 ep-text-secondary-text">{{ 'module.shared.legends.energyTypesLegendsLabelText.wasser' | translate }}</span>
      </div>
      <div class="indent-legend">
        <span class="icon" [ngClass]="(legendsService._isWasserVisible$ | async) ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
      </div>
    </div>
    <div class="layer-action producer-container" *ngIf="(legendsService.availableProducers$ | async)?.includes('Biomasse')" (click)="toggleIcons('Biomasse')">
      <div class="indent-container">
        <app-svg-icon class="filter-indent-arrow" src="./assets/icons/filter-indent-arrow.svg"></app-svg-icon>
        <span class="ep-text-regular-12 ep-text-secondary-text">{{ 'module.shared.legends.energyTypesLegendsLabelText.biomasse' | translate }}</span>
      </div>
      <div class="indent-legend">
        <span class="icon" [ngClass]="(legendsService._isBiomasseVisible$ | async) ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
      </div>
    </div>
  </ng-container>

  <div class="layer-action iot-container" *ngIf="!!authService.permissions.SENSOR_DATA" (click)="toggleIcons('iot')">
    <span class="ep-text-regular-12 ep-text-primary-text">{{ 'module.shared.legends.iotLegendsLabelText' | translate }}</span>
    <span class="icon" [ngClass]="(legendsService._isIotVisible$ | async) ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
  </div>
  <div class="legend-container" *ngIf="!!authService.permissions.ENERGY_MAP_STREETLIGHTS">
    <span class="ep-text-medium-14 title">Legende</span>
    <div class="legend-group" [ngClass]="legendGroup.type" *ngFor="let legendGroup of legends; trackBy: trackByFnLegends">
      <span class="ep-text-medium-12 ep-text-primary-text" *ngIf="legendGroup.title">{{ legendGroup.title }}</span>
      <div class="legend" *ngFor="let legend of legendGroup.content; trackBy: trackByFnContent">
        <div [ngClass]="legend.class"></div>
        <span class="ep-text-regular-12 ep-text-primary-text">{{ legend.name }}</span>
      </div>
    </div>
  </div>
  <span class="ep-text-medium-12 ep-text-primary-text" *ngIf="!!authService.permissions.EFFICIENCY_ANALYSIS">Effizienz</span>
  <div class="bottom-legend" *ngIf="!!authService.permissions.EFFICIENCY_ANALYSIS">
    <img alt="eff-analysis-img" class="icon" src="./assets/icons/efficiencyAnalysis.png" />Strom- / Wärmeeffizienz
  </div>
</div>
